import { useMutation } from "react-query";
import { message } from "antd";
import { axiosInstance } from "../../../../utils/axiosInstance";

export const useConfirmResetStudentPassword = () => {
  return useMutation(
    (validation: any) =>
      axiosInstance
        .post("/auth/confirm-reset", validation)
        .then((res: any) => res.data),
    {
      onSuccess: async (data: any) => {
        message.success(data?.message);
      },
      onError: (error: any) => {
        message.error(
          error?.response?.data?.message || "Login failed. Please try again."
        );
      },
    }
  );
};
